import { FC } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { PhoneStepNumberForm } from 'components/features/creditCard/creditCardOnboarding/PhoneStepNumberForm/PhoneStepNumberForm'
import { PhoneStepVerifyForm } from 'components/features/creditCard/creditCardOnboarding/PhoneStepVerifyForm/PhoneStepVerifyForm'

export const PhoneStepPage: FC = () => {
  const isNumberVerified = useStoreSelector((state) => state.app.creditCard.createPhoneRequest.data?.is_verified ?? null)

  if (isNumberVerified === false) {
    return (
      <PhoneStepVerifyForm />
    )
  }

  return (
    <PhoneStepNumberForm />
  )
}
